import http from '@/communication/AuthConnection'
import FormatListItem from './FormatListItem'

export default async ({ commit }, { eventId }) => {
  const { data } = await http.get(`/v1/item-pricing/list-all-items/${eventId}`)
  if (data) {
    const listItems = FormatListItem(data.eventItems)
    commit('SET_LIST_ITEMS', {
      listItems
    })

    commit('SET_DYNAMIC_COLUMNS', data.dynamicColumns)
    commit('GROUP_FILTERS')
    return data.eventItems
  } else {
    return Promise.reject(Error('Não foi possível carregar a listagem'))
  }
}



// WEBPACK FOOTER //
// ./src/brain/item-pricing/list-all-items/index.js